export const MARTIAL_STATUS = [{ value: "Married", label: "Married" }, { value: "Single", label: "Single" },
  { value: "Widowed", label: "Widowed" },
  { value: "Divorced", label: "Divorced" },
  { value: "Separated", label: "Separated" },
]
export const GENDER_STATUS = [{ value: "Male", label: "Male" }, { value: "Female", label: "Female" },
  { value: "Transgender", label: "Transgender" },
  { value: "Gender Neutral", label: "Gender Neutral" },
]

export const BLOOD_GROUP = [
    { label: "A+", value: "A+" },
    { label: "A-", value: "A-" },
    { label: "B+", value: "B+" },
    { label: "B-", value: "B-" },
    { label: "O+", value: "O+" },
    { label: "O-", value: "O-" },
    { label: "AB+", value: "AB+" },
    { label: "AB-", value: "AB-" },
]

export const ACCOUNT_TYPE = [
     { label: "Current", value: "Current" },
    { label: "Saving", value: "Saving" },
    { label: "Provident Fund", value: "Provident Fund" },
]

export const EMPLOYMENT_STATUS = [
  { value: "", label: "Select…" },
  { value: "Intern", label: "Intern" },
  { value: "Probation", label: "Probation" },
  { value: "Full time", label: "Full time" },
  { value: "Part time", label: "Part time" },
  { value: "Articleship", label: "Articleship" },
]